import React, { useRef, useState, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import MaterialTable, { MTableToolbar } from 'material-table';
import {
  Button,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Search, VerticalAlignBottom, Visibility } from '@material-ui/icons';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import Rating from '@material-ui/lab/Rating';
import { localizationTable, options } from 'constants/table';
import { ReportCompanyData } from 'services/dataService';
import RatingsDetailModal from '../DetailModal';
import { useStyles } from './styles';
import { useMediaQuery, useTheme } from '@material-ui/core';

export default ({ fields }) => {
  const [course, setCourse] = useState('');
  const [disable, setDisable] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [detailModal, setDetailModal] = useState({
    open: false,
    idCompanyCourse: null,
    courseName: '',
  });
  const tableRef = useRef();
  const history = useHistory();
  const classes = useStyles();
  const { register, handleSubmit } = useForm();
  const { t } = useTranslation(['tables']);

const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

const columnsField = fields.map((field) => {
  if (field.field === 'course_name') {
    return {
      ...field,
      sorting: false,
      cellStyle: {
      maxWidth: isMobile ? 160 : 400,
      whiteSpace: 'normal',
      overflowWrap: 'break-word',
      wordBreak: isMobile ? 'normal' : 'break-word',
  },
      headerStyle: {
        maxWidth: isMobile ? 160 : 400,
      },
    };
  }
  
  if (field.field === 'average_rating') {
    return {
      ...field,
      sorting: false,
      cellStyle: {
        textAlign: 'center',
      },
      headerStyle: {
        textAlign: 'center',
      },
      render: (rowData) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Rating
            value={Number(rowData.average_rating)}
            precision={0.1}
            readOnly
            size="small"
          />
          <span style={{ marginLeft: 8 }}>
            {Number(rowData.average_rating).toFixed(1)}
          </span>
        </div>
      ),
    };
  }
  if (field.field === 'ratings_count') {
    return {
      ...field,
      sorting: false,
      cellStyle: {
        textAlign: 'center',
      },
      headerStyle: {
        textAlign: 'center',
      },
    };
  }

  return {
    ...field,
    sorting: false,
  };
});

  const onSubmit = (data) => {
    setCourse(data.course);
    tableRef.current.state.query.page = 0;
    tableRef.current.onQueryChange();
  };

  const handleFetchToXlsx = async (columns) => {
    await ReportCompanyData.getRatingsToXlsx({
      course,
      isExport: true,
      columns: JSON.stringify(columns),
    });

    return [];
  };

  const existeRelatorioParaBaixar = () => {
    const res = localStorage.getItem('RelatorioRatingsDownload');

    if (res === '1') {
      setDisable(true);
    }
  };

  const customExport = useCallback(async () => {
    const RATINGS_EXPORT_COLUMNS = [
      { field: 'course_name', title: 'Curso', hidden: false },
      { field: 'name', title: 'Nome', hidden: false },
      { field: 'email', title: 'Email', hidden: false },
      { field: 'rating', title: 'Nota', hidden: false },
      { field: 'comment', title: 'Comentário', hidden: false },
      { field: 'created_at', title: 'Criado em', hidden: false },
        ];

    try {
    setDisable(true);
    localStorage.setItem('RelatorioRatingsDownload', '1');
    toast.info('Seu relatório está sendo gerado.');

    await handleFetchToXlsx(RATINGS_EXPORT_COLUMNS);
    setShowConfirmation(true);
  } catch (error) {
    toast.error(
      'Não foi possível gerar o relatório, tente novamente mais tarde.'
    );
  }
}, [course]);

  const handleClickConfirmSave = () => {
    setShowConfirmation(false);
    window.location.reload();
  };

  const handleNotificationClick = () => {
    history.push('/notification');
  };

  return (
    <div className="notranslate">
      <Dialog
        open={showConfirmation}
        onClose={() => setShowConfirmation(false)}
      >
        <DialogTitle style={{ fontSize: '22px', textAlign: 'center' }}>
          Atenção
        </DialogTitle>
        <DialogContent style={{ textAlign: 'center' }}>
          <Typography variant="subtitle1" gutterBottom>
            Em alguns instantes o seu Relatório de Avaliações estará disponível em
            Notificações.
          </Typography>
          <Typography variant="subtitle1">
            Basta clicar em <b>Notificações</b> &rarr; <b>Ver todas</b>
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleNotificationClick}
            style={{ padding: '10px 30px' }}
          >
            Notificações
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleClickConfirmSave}
            style={{ padding: '10px 50px' }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <RatingsDetailModal
        open={detailModal.open}
        idCompanyCourse={detailModal.idCompanyCourse}
        courseName={detailModal.courseName}
        onClose={() =>
          setDetailModal({ open: false, idCompanyCourse: null, courseName: '' })
        }
      />

      <MaterialTable
        title="Avaliações"
        tableRef={tableRef}
        columns={columnsField}
        data={async (query) => {
          try {
            const response = await ReportCompanyData.getRatingsReport({
              page: query.page + 1,
              limit: query.pageSize,
              course,
            });

            existeRelatorioParaBaixar();

            const { report, currentPage, totalCount } = response.data;

            return {
              data: report,
              page: currentPage - 1,
              totalCount,
            };
          } catch (error) {
            toast.error('Não foi possível buscar os dados do relatório.');
            return { data: [] };
          }
        }}
        components={{
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
              <form onSubmit={handleSubmit(onSubmit)}>
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item md={10} xs={12}>
                      <TextField
                        fullWidth
                        label="Curso"
                        name="course"
                        type="text"
                        variant="outlined"
                        defaultValue={course || ''}
                        inputRef={register}
                      />
                    </Grid>
                    <Grid item md={2} xs={12} className={classes.actions}>
                      <Button
                        color="primary"
                        variant="contained"
                        size="large"
                        type="submit"
                      >
                        <Search />
                        Filtrar
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </form>
            </div>
          ),
        }}
        localization={localizationTable(t)}
        actions={[
          {
            icon: () => (
              <Tooltip title="Somente após o download de um relatório solicitado, é possível solicitar novamente.">
                <span>
                  <Button disabled={disable} onClick={customExport}>
                    <VerticalAlignBottom />
                  </Button>
                </span>
              </Tooltip>
            ),
            isFreeAction: true,
          },
          {
            icon: () => (
              <Tooltip title="Ver avaliações detalhadas">
                <Visibility color="primary" />
              </Tooltip>
            ),
            onClick: (event, rowData) => {
              setDetailModal({
                open: true,
                idCompanyCourse: rowData.id_company_course,
                courseName: rowData.course_name,
              });
            },
          },
        ]}
        options={{
          ...options,
          exportButton: false,
        }}
      />
    </div>
  );
};